import { useLayoutEffect } from 'react';

import { EntityRefUtil } from '@gearbelt/global';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useParams } from 'react-router';
import { Link } from 'react-router-dom';

import ArrowRightIcon from '@/components/icons/arrow-right-small';
import { useTopbarStore } from '@/components/topbar/topbar-store';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { getAssetByIdQueryOptions } from '@/queries/assets';
import { getWorkspaceRoute } from '@/utils/routes';

import { AssetNavTabs } from './nav-tabs';

function AssetBreadcrumb() {
  const { id } = useParams();
  const { data: asset, isLoading: assetNameLoading } = useQuery(getAssetByIdQueryOptions({ assetId: id }));

  return (
    <div className="flex h-full items-center px-2">
      {assetNameLoading ? (
        <div className="bg-grey-2 h-6 w-48 animate-pulse rounded-md" />
      ) : (
        <Breadcrumb>
          <BreadcrumbList className="text-default-text sm:gap-1">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={getWorkspaceRoute('/assets')}>Assets</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="[&>svg]:size-[1.25rem]">
              <ArrowRightIcon />
            </BreadcrumbSeparator>
            <BreadcrumbItem>{asset ? EntityRefUtil.createAssetLabel(asset) : ''}</BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      )}
    </div>
  );
}

function AssetPage() {
  useLayoutEffect(() => {
    useTopbarStore.getState().setActions(<AssetBreadcrumb />);

    return () => {
      useTopbarStore.getState().setActions(<></>);
    };
  }, []);

  return (
    <div className="flex flex-1 overflow-hidden">
      <AssetNavTabs />
      <div className="bg-grey-1 flex flex-1 flex-col overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}

export default AssetPage;
